import { render, staticRenderFns } from "./PlateSearch.vue?vue&type=template&id=55b8df38&scoped=true&"
import script from "./PlateSearch.vue?vue&type=script&lang=js&"
export * from "./PlateSearch.vue?vue&type=script&lang=js&"
import style0 from "./PlateSearch.vue?vue&type=style&index=0&id=55b8df38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b8df38",
  null
  
)

export default component.exports